import { render, staticRenderFns } from "./PolimixProductionAndamentoStockDetail.vue?vue&type=template&id=60a54a37&"
import script from "./PolimixProductionAndamentoStockDetail.vue?vue&type=script&lang=js&"
export * from "./PolimixProductionAndamentoStockDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolimixProductionAndamentoStockDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports